export function jsonToSchema(json) {
    var schema = { type: void 0 };
    proItem({ schema: schema, val: json });
    if (schema.type) {
        return schema;
    }
    else {
        return;
    }
}
function proItem(_a) {
    var schema = _a.schema, val = _a.val, key = _a.key, fromAry = _a.fromAry;
    if (Array.isArray(val)) {
        var items = {};
        if (key) {
            schema[key] = {
                type: 'array',
                items: items
            };
        }
        else {
            schema.type = 'array';
            schema.items = items;
        }
        proAry(items, val);
    }
    else {
        if (typeof val === 'object' && val) {
            var nSchema = void 0;
            if (fromAry) {
                schema.type = 'object';
                nSchema = schema.properties = {};
            }
            var properties = fromAry ? nSchema : {};
            if (!fromAry) {
                if (key) {
                    schema[key] = {
                        type: 'object',
                        properties: properties
                    };
                }
                else {
                    schema.type = 'object';
                    schema.properties = properties;
                }
            }
            proObj(properties, val);
        }
        else {
            var type = val === null || val === void 0 ? 'any' : typeof val;
            if (key === void 0) {
                schema.type = type;
            }
            else {
                schema[key] = { type: type };
            }
        }
    }
}
function proObj(curSchema, obj) {
    Object.keys(obj).map(function (key) {
        return proItem({ schema: curSchema, val: obj[key], key: key });
    });
}
function proAry(curSchema, ary) {
    var sample;
    if (ary.length > 0) {
        sample = ary[0];
    }
    proItem({ schema: curSchema, val: sample, fromAry: true });
}
